import React from 'react';
import { useNavigate } from "react-router-dom";
import calendar from '../assets/calendar.svg';
import userIcon from '../assets/user-icon.svg';

interface LeadProps {
    id: number;
    raw_lead_id: number;
    cust_name: string;
    bhk: string;
    city: string;
    raw_lead_created_at: string;
    status: string;
    time: string;
    raw_leads_budget_max: number;
    raw_leads_budget_min: number;
    raw_leads_configuration: string;
    raw_leads_property_type: string;
    raw_leads_buying_location: string;
    customer_address: string;
    raw_leads_remarks: string;
    voice_note: string;
    despositions_name?: string; 
    last_updated?: string;      
    project_name?: string;   
    last_disposition?: string;    
}

const LeadCard: React.FC<LeadProps> = ({
    id,
    raw_lead_id,
    cust_name,
    bhk,
    city,
    raw_lead_created_at,
    status,
    time,
    raw_leads_budget_max,
    voice_note,
    raw_leads_budget_min,
    raw_leads_configuration,
    raw_leads_property_type,
    raw_leads_buying_location,
    customer_address,
    raw_leads_remarks,
    despositions_name,
    last_updated,
    project_name,
    last_disposition
}) => {
    const navigate = useNavigate();

    const handleLeadClick = () => {
        if (status === "notQualify") {
            navigate(`/rawlead/${raw_lead_id}`, {
                state: {
                    raw_lead_id,
                    cust_name,
                    bhk,
                    city,
                    raw_leads_budget_max,
                    raw_leads_budget_min,
                    raw_leads_configuration,
                    raw_leads_property_type,
                    raw_leads_buying_location,
                    customer_address,
                    raw_leads_remarks,
                    voice_note,
                    status,
                    project_name: city,
                    last_disposition
                }
            });
        } else {
            navigate(`/lead/${id}`, {
                state: {
                    id,
                    raw_lead_id,
                    cust_name,
                    bhk,
                    city,
                    raw_leads_budget_max,
                    raw_leads_budget_min,
                    raw_leads_configuration,
                    raw_leads_property_type,
                    raw_leads_buying_location,
                    customer_address,
                    raw_leads_remarks,
                    voice_note,
                    status,
                    despositions_name,
                    last_updated,
                    project_name: city,
                    last_disposition
                }
            });
        }
    };

    const displayId = (status === "notQualify") ? raw_lead_id : id;
    const displayIdLabel = (status === "notQualify") ? "Raw Lead ID" : "Lead ID";

    return (
        <div className="lead-card" style={{ cursor: "pointer" }} onClick={handleLeadClick}>
            <div className="left">
                <div className="avatar-test">
                    <img src={userIcon} alt='lead-user-icon' />
                </div>
                <div className="info">
                    <h4>{cust_name}</h4>
                    <p className="sub-text-test">{displayIdLabel}: {displayId}</p>
                    <p className="last-updated">
                        Last Updated: {last_updated || raw_lead_created_at || "Not Available"}
                    </p>
                    <p className="icon-text">
                        <img src={calendar} alt="" /> Added: {raw_lead_created_at?.trim() ? raw_lead_created_at : "N/A"}
                    </p>
                    <button className="remarks-button">
                        {last_disposition || "NA"}
                    </button>
                </div>
            </div>

            <div className="right">
                <span className={`badge ${status === 'active' ? 'active-badge' : 
                    status === 'invalid' ? 'invalid-badge' : 'notqualify-badge'}`}>
                    {status === 'active' ? 'Active' : 
                     status === 'invalid' ? 'Invalid' : 'Not Qualified'}
                </span>
                <p className="time">{time}</p>
            </div>
        </div>
    );
};

export default LeadCard;